import { render, staticRenderFns } from "./DirView.vue?vue&type=template&id=1fb7f2b6&"
import script from "./DirView.vue?vue&type=script&lang=js&"
export * from "./DirView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports